import styled from 'styled-components';

import { rem } from '@savgroup-front-common/primitive/helpers/units';

export const Description = styled.div`
  white-space: pre-wrap;
  margin-bottom: ${rem(14)};
`;
